import Swal from "sweetalert2/dist/sweetalert2.js";

interface SwalParams {
    title: string;
    msg: string;
    icon: 'info' | 'error' | 'warning' | 'success' | 'question';
}
interface SwalInfoParams {
    title: string;
    msg: string;
}

export const SwalError = (args: SwalInfoParams) => {
    return Swal.fire({
        title: args.title,
        text: args.msg,
        icon: 'error',
    });
}

export const SwalInfo = (args: SwalInfoParams) => {
    return Swal.fire({
        title: args.title,
        text: args.msg,
        icon: 'info',
    });
}

export const SwalWarning = (args: SwalInfoParams) => {
    return Swal.fire({
        title: args.title,
        text: args.msg,
        icon: 'warning',
    });
}

export const SwalSuccess = (args: SwalInfoParams) => {
    return Swal.fire({
        title: args.title,
        text: args.msg,
        icon: 'success',
    });
}

export const SwalSuccessHtml = (args: SwalInfoParams) => {
    return Swal.fire({
        title: args.title,
        html: args.msg,   // allows <span>, <strong>, etc.
        icon: 'success',
    });
}

export const SwalConfirm = (args: SwalParams) => {
    return Swal.fire({
        title: args.title,
        text: args.msg,
        icon: args.icon,
        showCancelButton: true,
        cancelButtonText: 'Tidak',
        confirmButtonText: 'Ya',
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger',
        }
    });
}

export const SwalBlock = (args: SwalParams) => {
    return Swal.fire({
        title: args.title,
        text: args.msg,
        icon: args.icon,
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
    });
}

export const SwalClose = () => {
    Swal.close();
};